import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Card, Col, Form, Row } from 'react-bootstrap';
import MyApiClient from '../../../../api-client/MyApiClient';
import { usePageTitle, useStatoInSolaLettura } from '../../../layouts/PageHeaderExtra';

/*
 * Scheda di un pagamento DonAction della struttura (03/10/2026). Prima la riga di «Pagamenti DonAction»
 * apriva una finestra con gli utenti DonAction del pagamento; ora è una pagina. Il pagamento non ha un id
 * suo: nell'indirizzo c'è la data di inizio del periodo, e si rilegge dall'elenco dei pagamenti.
 */

const data = (v) => (v ? new Date(v).toLocaleDateString('it-IT') : '—');

export const PagamentoDonAction = () => {
    const { da } = useParams();
    const location = useLocation();
    const [pagamento, setPagamento] = useState(location.state?.pagamento || null);
    const [caricato, setCaricato] = useState(false);

    useEffect(() => {
        const carica = async () => {
            const dettagli = sessionStorage.getItem('userDetails');
            if (!dettagli) return;
            try {
                const pagamenti = await new MyApiClient().getClubReferralTransactions(JSON.parse(dettagli).idToken);
                const trovato = (pagamenti || []).find((p) => String(p.startDate) === String(da));
                if (trovato) {
                    setPagamento({
                        numberOfReferral: trovato.numberOfReferral,
                        numberOfReferralEarn: '€ ' + (trovato.numberOfReferral * 10).toFixed(2),
                        startDate: trovato.startDate,
                        endDate: trovato.endDate,
                        transactionEmail: trovato.transactionEmail,
                        payedTime: trovato.createdAt ?? null,
                    });
                }
            } catch (e) {
                console.error(e);
            } finally {
                setCaricato(true);
            }
        };
        carica();
    }, [da]);

    usePageTitle(pagamento ? `Pagamento DonAction dal ${data(pagamento.startDate)} al ${data(pagamento.endDate)}` : '');
    useStatoInSolaLettura(pagamento ? 'Pagato' : '', 'attivo');

    if (!pagamento) {
        return (
            <>
                <Card>
                    <Card.Body className="sid-card-body--spaced">
                        {caricato ? 'Pagamento non trovato.' : 'Caricamento in corso...'}
                    </Card.Body>
                </Card>
            </>
        );
    }

    return (
        <>
            <Card>
                <Card.Body className="sid-card-body--spaced">
                    <h5 className="sid-form-section">Pagamento</h5>
                    <Row className="g-4">
                        <Col md={6}>
                            <Form.Label>Da data</Form.Label>
                            <div className="sid-readonly-value">{data(pagamento.startDate)}</div>
                        </Col>
                        <Col md={6}>
                            <Form.Label>A data</Form.Label>
                            <div className="sid-readonly-value">{data(pagamento.endDate)}</div>
                        </Col>
                        <Col md={6}>
                            <Form.Label>Numero DonAction</Form.Label>
                            <div className="sid-readonly-value">{pagamento.numberOfReferral ?? '—'}</div>
                        </Col>
                        <Col md={6}>
                            <Form.Label>Importo</Form.Label>
                            <div className="sid-readonly-value">{pagamento.numberOfReferralEarn || '—'}</div>
                        </Col>
                        {pagamento.payedTime && (
                            <Col md={6}>
                                <Form.Label>Pagato il</Form.Label>
                                <div className="sid-readonly-value">{data(pagamento.payedTime)}</div>
                            </Col>
                        )}
                    </Row>

                    <h5 className="sid-form-section mt-4">Utenti DonAction</h5>
                    <div className="sid-readonly-value" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                        {pagamento.transactionEmail || '—'}
                    </div>
                </Card.Body>
            </Card>

        </>
    );
};

export default PagamentoDonAction;
